<template>
    <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5H15" stroke="#C000AF" stroke-linecap="square" stroke-linejoin="round" />
        <path d="M12.1758 9L16.1758 5L12.1758 1" stroke="#C000AF" stroke-linecap="square" />
    </svg>
</template>
